import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class PdfUserGuidesService {

  constructor(public http: AppHttpClient) { }

  getPdfs() {
    return this.http.get('user-guide-pdfs');
  }

  uploadPdf(payload: { fileName: string; fileContent: string }) {
    return this.http.post('user-guide-pdfs', payload);
  }

  deletePdf(key: string) {
    return this.http.delete(`user-guide-pdfs/${encodeURIComponent(key)}`);
  }
}
